import { SAVE_NEWS, SET_LOADING_NEWS } from './actionTypes'
import { NewsModel } from '../../../types/news/newsModel'
import { NewsType } from './types'

export const saveNews = (news: NewsModel): NewsType => {
	return ({
		type: SAVE_NEWS,
		payload: news
	})
}

export const setLoadingNews = (loading: boolean): NewsType => {
	return ({
		type: SET_LOADING_NEWS,
		payload: loading
	})
}
